// Localization popup
window.langLabelsVars = {
  "en": {
    "en": {
      "langName": "English"
    },
    "pl": {
      "langName": "Polish"
    },
    "country": "Country"
  },
  "pl": {
    "en": {
      "langName": "Angielski"
    },
    "pl": {
      "langName": "Polski"
    },
    "country": "Kraj"
  },
  "de": {
    "de": {
      "langName": "Deutsch"
    },
    "en": {
      "langName": "English"
    },
    "pl": {
      "langName": "Polski"
    },
    "country": "Land"
  },
}

document.querySelector('.localization-popup__currency-wrapper').addEventListener('click', function () {
  document.querySelector('.localization-popup__lang-list').classList.remove('active');
  document.querySelector('.localization-popup__currencies-list').classList.toggle('active');
});

document.querySelector('.localization-popup__lang-wrapper').addEventListener('click', function () {
  document.querySelector('.localization-popup__currencies-list').classList.remove('active');
  document.querySelector('.localization-popup__lang-list').classList.toggle('active');
});

for (var i = 0; i < document.querySelectorAll('.localization-popup__currency-option').length; i++) {
  document.querySelectorAll('.localization-popup__currency-option')[i].addEventListener('click', function () {
    // document.querySelector('.localization-popup__currencies-list').classList.remove('active');
    let currency = this.getAttribute('data-currency');
    let flag = this.getAttribute('data-flag');
    let country = this.getAttribute('data-country');
    let isoCode = this.getAttribute('data-iso-code');

    document.querySelector('.localization-popup__active-currency').innerHTML = currency;
    document.querySelector('.localization-popup__flag > img').setAttribute('src', flag);
    document.querySelector('.localization-popup__country-code').innerHTML = country;
    document.querySelector('.localization-popup__country-code').setAttribute('data-country-iso-code', isoCode);

    document.querySelector('.localization-popup__apply').click();

  });
}

for (var i = 0; i < document.querySelectorAll('.localization-popup__lang-option').length; i++) {
  document.querySelectorAll('.localization-popup__lang-option')[i].addEventListener('click', function () {
    document.querySelector('.localization-popup__lang-list').classList.remove('active');
    let langOption = this.querySelector('span').innerHTML;
    let langCode = this.querySelector('span').getAttribute('data-lang');
    document.querySelector('.localization-popup__lang-wrapper > div > span').innerHTML = langOption;
    document.querySelector('.localization-popup__lang-wrapper > div > span').setAttribute('data-lang', langCode);
  });
}

function convertPrices(targetCurrency) {
  // return;
  let currencySymbol = defaultCurrency;
  if (targetCurrency == "PLN") {
    currencySymbol = "zł";
  } else {
    currencySymbol = "&euro;";
  }
  document.querySelectorAll('[data-base-price]').forEach(price => {
    let priceValue = Number(price.getAttribute('data-base-price')) / 100;
    let convertedPrice = Currency.convert(priceValue, defaultCurrency, targetCurrency).toFixed(2);
    price.innerHTML = convertedPrice + " " + currencySymbol;
  });
}
// window.convertPrices = function(targetCurrency) {
//  convertPrices(targetCurrency);
// }

// change currency and country from previous settings
let currentLang = localStorage.getItem("currentLang") || window.Shopify.locale;
let defaultCurrency = window.Shopify.currency.active;
let currentCurrency = localStorage.getItem("currentCurrency") || defaultCurrency;
let currentCountry = localStorage.getItem("currentCountry") || window.langLabelsVars[currentLang].country;
let currentMarket = localStorage.getItem("currentMarket") || document.querySelector('.localization-popup__country-code').getAttribute('data-country-iso-code');
let currentFlag = localStorage.getItem("currentFlag") || document.querySelector('.localization-popup__flag > img').getAttribute('data-default');
if (defaultCurrency !== currentCurrency) {
  convertPrices(currentCurrency);
}
document.querySelector('.localization-popup__active-currency').innerHTML = currentCurrency;
document.querySelector('.localization-popup__country-code').innerHTML = currentCountry;
document.querySelector('.localization-popup__flag > img').setAttribute('src', currentFlag);
document.querySelector('.localization-popup__country-code').setAttribute('data-country-iso-code', currentMarket);


document.addEventListener('cart:change', (e) => {
  convertPrices(currentCurrency);
  setTimeout(function () {
    convertPrices(currentCurrency);
  }, 2000);
});

document.addEventListener('line-item:change', (e) => {
  convertPrices(currentCurrency);
});

document.addEventListener('reveal:items', (e) => {
  convertPrices(currentCurrency);
});

document.addEventListener('variant:change', (e) => {
  convertPrices(currentCurrency);
});

// change language from previous settings
if (currentLang == "pl") {
  var langName = window.langLabelsVars[currentLang][currentLang].langName;
} else {
  var langName = window.langLabelsVars[currentLang][currentLang].langName;
}

document.querySelector('.localization-popup__lang-wrapper > div > span').innerHTML = langName;
document.querySelector('.localization-popup__lang-wrapper > div > span').setAttribute('data-lang', currentLang);

// preload language switchers
function updateSwitchers(currentFlag, currentLang, currentCurrency) {
  document.querySelectorAll('.currency-switcher__flag > img').forEach(flag => {
    flag.setAttribute('src', currentFlag);
  });
  document.querySelectorAll('.currency-switcher__country-code').forEach(country => {
    country.innerHTML = currentLang.toUpperCase();
  });
  document.querySelectorAll('.currency-switcher__active-currency').forEach(currency => {
    currency.innerHTML = currentCurrency.toUpperCase();
  });
}
updateSwitchers(currentFlag, currentLang, currentCurrency);

document.querySelector('.localization-popup__apply').addEventListener('click', function () {
  let selectedLang = document.querySelector('.localization-popup__lang-wrapper > div > span').getAttribute('data-lang');
  document.querySelector('.localization-popup-wrapper').classList.remove('active');

  let defaultCurrency = window.Shopify.currency.active;
  let currentCurrency = localStorage.getItem("currentCurrency") || defaultCurrency;
  let selectedCurrency = document.querySelector('.localization-popup__active-currency').innerHTML.trim();
  let currentCountry = document.querySelector('.localization-popup__country-code').innerHTML.trim();
  let currentMarket = document.querySelector('.localization-popup__country-code').getAttribute('data-country-iso-code');
  let currentFlag = document.querySelector('.localization-popup__flag > img').getAttribute('src');
  console.log('Current currency: ' + currentCurrency);
  console.log('Currency to change: ' + selectedCurrency);

  if (selectedCurrency !== currentCurrency) {
    convertPrices(selectedCurrency);
    localStorage.setItem("currentCurrency", selectedCurrency);
  }
  localStorage.setItem("currentCountry", currentCountry);
  localStorage.setItem("currentFlag", currentFlag);
  localStorage.setItem("currentMarket", currentMarket);

  // Override settings
  if (currentMarket == 'PL') {
    selectedLang = 'pl';
  } else if (currentMarket == 'DE') {
    selectedLang = 'de';
  } else {
    selectedLang = 'en';
  }

  let selectedLangForSwitcher = selectedLang;
  localStorage.setItem("currentLang", selectedLang);

  const pathnameWithoutLocale = window.location.pathname.replace(/^\/(en|pl|de)(?=\/|$)/, '') || '/';
  let targetPathname = pathnameWithoutLocale;

  if (selectedLang !== 'pl') {
    targetPathname = '/' + selectedLang + (pathnameWithoutLocale === '/' ? '' : pathnameWithoutLocale);
  }

  const urlToRedirect = new URL(window.location.origin + targetPathname);
  urlToRedirect.searchParams.set('country', currentMarket);

  updateSwitchers(currentFlag, selectedLangForSwitcher, selectedCurrency);
  document.querySelector('.localization-popup-wrapper').classList.remove('active');

  console.log('urlToRedirect: ' + urlToRedirect.toString());
  window.location.replace(urlToRedirect.toString());
});

document.querySelectorAll('localization-form').forEach(switcher => {
  switcher.addEventListener('click', function () {
    document.querySelector('.localization-popup-wrapper').classList.add('active');
    document.querySelector('html').classList.add('lock');
  });
});

document.querySelector('.localization-popup__close').addEventListener('click', function (e) {
  document.querySelector('html').classList.remove('lock');
  let currentLang = localStorage.getItem("currentLang") || window.Shopify.locale;
  let defaultCurrency = window.Shopify.currency.active;
  let currentCurrency = localStorage.getItem("currentCurrency") || defaultCurrency;
  let currentCountry = localStorage.getItem("currentCountry") || window.langLabelsVars[currentLang].country;
  let currentMarket = localStorage.getItem("currentMarket") || window.Shopify.country;
  let currentFlag = localStorage.getItem("currentFlag") || document.querySelector('.localization-popup__flag > img').getAttribute('data-default');
  if (currentLang == "pl") {
    var langName = window.langLabelsVars[currentLang][currentLang].langName;
  } else {
    var langName = window.langLabelsVars[currentLang][currentLang].langName;
  }
  document.querySelector('.localization-popup__lang-wrapper > div > span').innerHTML = langName;
  document.querySelector('.localization-popup__lang-wrapper > div > span').setAttribute('data-lang', currentLang);
  document.querySelector('.localization-popup__active-currency').innerHTML = currentCurrency;
  document.querySelector('.localization-popup__country-code').innerHTML = currentCountry;
  document.querySelector('.localization-popup__flag > img').setAttribute('src', currentFlag);
  document.querySelector('.localization-popup-wrapper').classList.remove('active');
  document.querySelector('.localization-popup__country-code').setAttribute('data-country-iso-code', currentMarket);
});

//geolocation
// if (localStorage.getItem('geolocation') !== 'true') {  
//   fetch("https://ipinfo.io/json?token=caaf8c9f0f6082").then(
//     (response) => response.json()
//   ).then(
//     (jsonResponse) => {
//       var currentLang = localStorage.getItem("currentLang") || window.Shopify.locale;
//       var geoCountry = jsonResponse.country;
//       console.log(geoCountry);
//       if (geoCountry == 'GB') {
//         geoCountry = 'UK';
//       }
//       var geoCountryObj = window.geoCountry;
//       var countryObj = geoCountryObj.find(o => o.iso_code === geoCountry);

//       // if a country is not present at metaobject entries list
//       // if (countryObj === undefined) {
//       //   var countryObj = geoCountryObj.find(o => o.iso_code === 'UK');
//       // }else{
//       //   var countryObj = geoCountryObj.find(o => o.iso_code === geoCountry);
//       // }

//       if (countryObj !== undefined) {        
//         let flag = document.querySelector('.localization-popup__currency-option[data-iso-code=' + countryObj.iso_code + '] > img').getAttribute('src');
//         console.log(currentLang);
//         let langName = window.langLabelsVars[currentLang][currentLang].langName;
//         updateSwitchers(flag, countryObj.iso_code, countryObj.currency);

//         document.querySelector('.localization-popup__lang-wrapper > div > span').innerHTML = langName;
//         document.querySelector('.localization-popup__lang-wrapper > div > span').setAttribute('data-lang', currentLang);
//         document.querySelector('.localization-popup__flag > img').setAttribute('src', flag);
//         document.querySelector('.localization-popup__country-code').innerHTML = countryObj.country;
//         document.querySelector('.localization-popup__country-code').setAttribute('data-country-iso-code', countryObj.iso_code);
//         document.querySelector('.localization-popup__active-currency').innerHTML = countryObj.currency;
//         localStorage.setItem('geolocation', 'true');
//         localStorage.setItem('currentCountry', countryObj.country);
//         localStorage.setItem('currentFlag', flag);
//         localStorage.setItem('currentMarket', countryObj.iso_code);

//         console.log('geolocation applied');
//         document.querySelector('.localization-popup__apply').click();
//       }

//   });
// }

let switchers = document.querySelectorAll('.currency-switcher-wrapper');

switchers.forEach((switcher) => {
  let trigger = switcher.querySelector('.currency-switcher');
  let list = switcher.querySelector('.currency-switcher-dropdown');
  // let options   = switcher.querySelectorAll('.localization-popup__currency-option');

  trigger.addEventListener('click', () => {
    list.classList.toggle('is-active');
  });

});

// console.log("currentMarket: " + localStorage.getItem("currentMarket"));
// console.log("currentCurrency: " + localStorage.getItem("currentCurrency"));
// console.log("currentCountry: " + localStorage.getItem("currentCountry"));
// console.log("selectedCurrency: " + localStorage.getItem("selectedCurrency"));

const urlParams = new URLSearchParams(window.location.search);
const urlLang = window.location.pathname.split('/')[1];

if (urlLang === 'en' || urlParams.get('lang') === 'en') {
  var urlToRedirect = window.location.origin + '/en' + window.location.pathname.replace('/' + 'en', '') + '?country=UK';
  //if (localStorage.getItem("currentCurrency")!='EUR')
  //window.location.replace(urlToRedirect);
  console.log('urlToRedirect:', urlToRedirect);
  localStorage.setItem("currentMarket", 'UK');
  localStorage.setItem("currentLang", 'en');
  localStorage.setItem("currentCurrency", 'EUR');
  convertPrices('EUR')
}
else if (urlLang === 'de' || urlParams.get('lang') === 'de') {
  var urlToRedirect = window.location.origin + '/de' + window.location.pathname.replace('/' + 'de', '') + '?country=DE';
  //if (localStorage.getItem("currentCurrency")!='EUR')
  //window.location.replace(urlToRedirect);
  console.log('urlToRedirect:', urlToRedirect);
  localStorage.setItem("currentMarket", 'DE');
  localStorage.setItem("currentLang", 'de');
  localStorage.setItem("currentCurrency", 'EUR');
  convertPrices('EUR')
}
else if (urlLang === 'pl' || urlParams.get('lang') === 'pl') {
  var urlToRedirect = window.location.origin + '/pl' + window.location.pathname.replace('/' + 'pl', '') + '?country=PL';
  //if (localStorage.getItem("currentCurrency")!='EUR')
  //window.location.replace(urlToRedirect);
  console.log('urlToRedirect:', urlToRedirect);
  localStorage.setItem("currentMarket", 'PL');
  localStorage.setItem("currentLang", 'pl');
  localStorage.setItem("currentCurrency", 'PLN');
  convertPrices('PLN')
}
